import { DiagnosticsStackDeviceMainStructure } from '../remote-diagnostics-topology.model';
import { DiagnosticsStackGenericResponse } from '../remote-diagnostics.model';

export const BusTopologyPhaseOne_vitocal222: DiagnosticsStackGenericResponse<
  DiagnosticsStackDeviceMainStructure[]
> = {
  type: 'BusTopologyPhaseOne',
  structure: [
    {
      TI: 'TI_7959246',
      name: 'Master Device',
      structure: [
        {
          RES: ' 62 01 79 37 39 35 39 32 34 36 32 30 31 30 30 36 31 32 31',
          request_parameter_name: 'PA_DataIdent',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ReadDataByIdent',
          ecu: 'LL_0000_Main_ECU_CAN01',
          requestDate: '2023-04-21T10:15:12.703+0000',
          ecuvariant: 'LL_0000_Main_ECU_CAN01',
          request_parameter_value: 'ViessmannIdentificationNumber',
          securitystatus: 'ECU is unlocked !!!',
          type: 'ECU response structure by parameter name and value',
          structure: [
            {
              semantic: 'SERVICE-ID',
              path: 'PA_ServiID',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_ServiID',
              value: '98',
            },
            {
              semantic: '',
              path: 'PA_DataIdent',
              unit: '',
              translationid: '',
              dopname: '2 Byte Text Table VDD-Greenbook',
              name: 'PA_DataIdent',
              value: 'ViessmannIdentificationNumber',
            },
            {
              semantic: '',
              path: 'PA_DataRecor',
              translationid: '',
              dopname: '2 Byte Table VDD Greenbook',
              name: 'PA_DataRecor',
              structure: [
                {
                  semantic: 'ITEMID',
                  path: 'PA_DataRecor/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  dopname: '7 Byte Identical ItemId',
                  name: 'PA_ItemId',
                  value: '7959246',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  path: 'PA_DataRecor/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Year',
                  value: '2',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  dopname: '5 Byte Identical ProcessCounter',
                  name: 'PA_ProceCount',
                  value: '01006',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfCountOne',
                  value: '1',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfTwo',
                  value: '2',
                },
                {
                  semantic: 'VALUE',
                  path: 'PA_DataRecor/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Check',
                  value: '1',
                },
              ],
            },
            {
              semantic: '',
              path: 'PA_RecorDataIdentCheck',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_RecorDataIdentCheck',
              value: '',
            },
          ],
          REQ: ' 22 01 79',
        },
        {
          name: 'Main ECU',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0020_HPMU_CAN01',
              translationid: 'TI_LL_0020_HPMU_CAN01',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5092244_612101',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_HPMUMaster',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'HPMUMaster',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: '',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Funct',
                          unit: '',
                          translationid: 'TI_Function',
                          TI_texttableentry: 'TI_VitocalTwoHundredTwentyOneS',
                          dopname: '1 Byte TextTable DeviceFunctionHPMU',
                          name: 'PA_Funct',
                          value: 'VitocalTwoHundredTwentyOneS',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '20',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '509',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2244',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '174',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '2',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '612',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '101',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '4',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7470714',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '02200',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Additional ECUs',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[3]',
              logicallinkname: 'LL_0040_EHCU_CAN67',
              translationid: 'TI_LL_0040_EHCU_CAN67',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5092241_500700',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '67',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_EHCU',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'EHCU',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '40',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '509',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2241',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '110',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '40',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '700',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7632442',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '04548',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[2]',
              logicallinkname: 'LL_0083_ADIO_CAN66',
              translationid: 'TI_LL_0083_ADIO_CAN66',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5002243_402401',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '66',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_ADIO',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'ADIO',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable GenericAnalogDigitalAccessoryFunction',
                          name: 'PA_Value',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '83',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2243',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '44',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '402',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '401',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '3',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7470654',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00128',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Accessories',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0027_EM_CAN97',
              address: '1',
              translationid: 'TI_LL_0027_EM_CAN97',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '10201_10000',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '97',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanExternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanExternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_EnergyMeter',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'EnergyMeter',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: '',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Funct',
                          unit: '',
                          translationid: 'TI_Function',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable EnergyMeter',
                          name: 'PA_Funct',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '102',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '5',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '100',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '0102000',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '13700',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '7',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[4]',
              logicallinkname: 'LL_0059_VCMU_CAN54',
              address: '6',
              translationid: 'TI_LL_0059_VCMU_CAN54',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5022302_500708',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '54',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_VCMU',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'VCMU',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '59',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '502',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2302',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '10',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '59',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '708',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7873917',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '3',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00001',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0087_HMI_CAN59',
              address: '11',
              translationid: 'TI_LL_0087_HMI_CAN59',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002241_500500',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '59',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_HMI',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'HMI',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '87',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2241',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '11',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '87',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '2',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: 'HMI-MIN',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: 'I',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: 'MAL--',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0068_TCU_CAN58',
              address: '10',
              translationid: 'TI_LL_0068_TCU_CAN58',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5092247_400400',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '58',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BackendGateway',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BackendGateway',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUM',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_BackeGatew',
                          unit: '',
                          translationid: 'TI_BackendGateway',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable BackendGateway',
                          name: 'PA_BackeGatew',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '68',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '509',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2247',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '4',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '68',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '400',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '400',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7952592',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00011',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'OfflineECUs',
          structure: [
            {
              logicallinkname: 'LL_0003_HMI_CAN59',
              translationid: 'TI_LL_0003_HMI_CAN59',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0010_WiFi_CAN58',
              translationid: 'TI_LL_0010_WiFi_CAN58',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0063_TCU_CAN68',
              translationid: 'TI_LL_0063_TCU_CAN68',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0071_HMI_CAN59',
              translationid: 'TI_LL_0071_HMI_CAN59',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
          ],
        },
        {
          request_parameter_name: 'PA_ItemNumbe',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ProduDefin',
          ecu: 'LL_0000_Main_ECU_CAN01',
          bundleID: 'B_00061_VC250A_MPK',
          request_parameter_value: '7959246',
          type: 'RequestStructureByParameterNameAndValue',
        },
      ],
    },
  ],
};
